export const ALERT = {
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    PROGRESS: 4,
    QUESTION: 5
};

export const Alert = (inner, status = ALERT.INFO) => {
    alert(inner);
};

export const Confirm = (inner, status = ALERT.QUESTION) => {
    return confirm(inner);
};



// WEBPACK FOOTER //
// ./bundle/alert.js